<span
  class="icon-inline"
  v-tooltip.bottom="tooltipOptions"
>
  <component
    :is="svgComponent"
    viewBox="0 0 834 480"
    preserveAspectRatio="xMidYMid meet"
    :style="svgStyle"
  />
</span>
